import { types } from 'mobx-state-tree';

import OrderProduct from '../OrderProduct';

// This probably becomes obsolete in the near future.
// For now to get the proposal page to work
const OrderProposalProduct = types
  .compose(
    OrderProduct,
    types.model('OrderProposalProduct', {
      final_unit_price: types.maybeNull(types.number),
      image: types.maybeNull(types.string),
      multiproduct_title: types.maybeNull(types.string),
      starting_unit_price: types.maybeNull(types.number),
      total_price: types.maybeNull(types.number),
      url: types.maybeNull(types.string),
    })
  )
  .named('OrderProposalProduct');

export default OrderProposalProduct;
